import { WSTable, WSTableItem } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { PayeeRow, WorkLog } from "@wingspanhq/wingspan-api-sdk";
import { getColumns } from "./columns";

export type TableItemData = WorkLog;

type Props = {
  workLogs: WorkLog[];
  payeesMap: Map<string, PayeeRow>;
  onRowClick?: (workLog: WorkLog) => void;
  selection?: WSTableItem<WorkLog>[];
  onSelectionChange?: (selection: WSTableItem<WorkLog>[]) => void;
};

export const TableWorkLogsPayerView: React.FC<Props> = props => {
  const tableData = useMemo(() => {
    return props.workLogs.map(workLog => ({
      id: workLog.id ?? "",
      data: workLog
    }));
  }, [props.workLogs]);

  const columns = useMemo(
    () => getColumns({ payeesMap: props.payeesMap }),
    [props.payeesMap]
  );

  const handleRowClick = props.onRowClick
    ? (item: { id: string; data: WorkLog }) => props.onRowClick!(item.data)
    : undefined;

  return (
    <WSTable<TableItemData>
      tableData={tableData}
      columns={columns}
      onRowClick={handleRowClick}
      selection={props.selection}
      onSelectionChange={props.onSelectionChange}
    />
  );
};
